export const signature = {
  editor: "Edit the placement of signatures",
  aucun: "No document uploaded",
  desiner: "Please draw your signature.",
  entreText: "Please enter text.",
  importImge: "Please upload an image.",
  succes: "Signature sent successfully!",
  erreur: "Error while sending.",
  raisonRefus: "Please enter a reason for refusal.",
  erreurRefus: "Error while sending refusal.",
  signDoc: "Sign the document",
  destinataire: "Recipient",
  refus: "Refuse",
  rempliRefus: "Please provide the reason for refusal",
  envoieRefus: "Send refusal",
  annuler: "Cancel",
  emailEnvoyee: "Emails sent successfully!",
  emailErreur: "Error while sending emails.",
  enCours: "Sending in progress...",
  envoyerDes: "Send the link to recipients",
  emailSucces: "Sent successfully",
  token: "Token missing!",
  moinChamp: "Please fill in at least one field.",
  erreurSignature: "Error while applying signatures",
  applique: "Signature applied",
  appliquer: "Apply signature",
  choisirSign: "Choose a signature",
  votreNom: "Enter your full name",
  import: "Upload an image",
  genererSign: "Generate a signature",
  nom: "Full name",
  check: "Apply this prefix to all prefix fields",
  valid: "Validate",
  generateur: "Signature generator",
  entreNom: "Enter your name",
  gener: "Generate",
  tousRempli: "All fields must be filled",
  orderValide: "Each recipient must have a valid order",
  orderUnique: "Each recipient must have a unique order",
  docNonCharge: "Document not uploaded",
  destinataireSucces: "Recipients saved successfully",
  errorEnreg: "Error while saving",
  choixDes: "Choose recipients",
  ajoutDes: "Add a recipient",
  avecOrder: "Send with order",
  enregiestrer: "Save",
  emplSave: "Placements saved!",
  erreurSave: "Error while saving",
  place: "Place fields in the document",
  nomFichier: "File name displayed here",
  selectionne: "⚠️ No file selected.",
  pdfUnique: "⚠️ Please select a PDF file only.",
  aucunFichier: "⚠️ No file selected.",
  erreurUpload: "Error while uploading",
  erruerEnvoi: "❌ File sending error.",
  choixFichierPDF: "Choose a PDF file",
  fichier: "Choose a file",
};
